import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BarLoader } from 'react-spinners';

class LoadingBar extends Component {
  render() {
    const { app } = this.props;

    let color = '#666';

    if (app.season) {
      if (app.season.id === '2018') {
        color = '#24365F';
      } else if (app.season.id === '2019') {
        color = '#0067BC';
      }
    }

    return (
      <div className="loading-bar">
        <BarLoader
          color={ color }
          loading={ true }
          width={ 250 } />
        <p>Loading...</p>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  app: state.app
});

export default connect(mapStateToProps)(LoadingBar);


// WEBPACK FOOTER //
// ./src/components/loading-bar/loading-bar.js